import * as React from "react";
import { connect } from "react-redux";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import * as redux from "redux";
import { Authorship, Details, Permissions, Settings } from "./components";
import { Navigation } from "./components/Navigation";
import { Uploads } from "./components/Uploads";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import { AdminAbstractAndTypeLoader } from "../../../containers/abstracts/components";
import * as M from "../../../models";
import { AppState } from "../../../store";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...Comp.Base.DefaultStatePropsMap(state, ownProps),
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...Comp.Base.DefaultDispatchPropsMap(dispatch),
});

type OwnProps = RouteComponentProps<{
    guid: string;
}> & {
    eventId: number;
};

type ConnectedState = Comp.Base.DefaultConnectedState & {
};

type ConnectedDispatch = Comp.Base.DefaultConnectedDispatch & {
};

interface OwnState {
    abstract?: M.Abstract.Abstract;
    type?: M.Abstract.AbstractType;
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class EditComponent extends Comp.Base.BaseComponent<CombinedProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    public componentDidMount() {
        this._isMounted = true;
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        const a = this.state.abstract;
        const type = this.state.type;
        const match = this.props.match;
        const guid = this.props.match.params.guid;
        const eventId = this.props.eventId;
        const isNew = guid === "new";
        const loading = this.state.loading;

        const preContent = <h1>
            <Link to={Paths.AdminAbstractList(eventId)}>Abstracts</Link> &raquo; {isNew ? "Add new abstract" : "Edit"}
        </h1>;

        return <Comp.Page.AdminPage
            mainClass="results"
            preContent={preContent}
            title="Abstracts"
        >
            <Comp.Generic.LoadingSpinner show={loading} />

            {!isNew
                ? <AdminAbstractAndTypeLoader
                    guid={guid}
                    onDataUpdated={async (dataLoading, updatedAbstract, updatedType) => await this.setStateAsync({
                        ...this.state,
                        abstract: updatedAbstract,
                        type: updatedType,
                        loading: dataLoading,
                    })}
                    onErrors={(errors) => this.setErrors(errors)}
                />
                : null}

            <div className="results-filters">
                <Comp.Access.AdminRoute
                    exact
                    path={match.path + "/:view?"}
                    render={(props) => <Navigation eventId={eventId} guid={guid} isNew={isNew} view={props.match.params.view} />}
                />
            </div>

            <div className="results-list">
                <Comp.Access.AdminRoute exact path={match.path} render={(props) => <Authorship abstract={a} eventId={eventId} type={type} { ...props} />} />
                {a && type
                    ? <>
                        <Comp.Access.AdminRoute exact path={match.path + "/details"} render={(props) => <Details abstract={a!} eventId={eventId} type={type!} { ...props} />} />
                        <Comp.Access.AdminRoute exact path={match.path + "/uploads"} render={(props) => <Uploads abstract={a!} eventId={eventId} type={type!} { ...props} />} />
                        <Comp.Access.AdminRoute exact path={match.path + "/permissions"} render={(props) => <Permissions abstract={a!} eventId={eventId} { ...props} />} />
                        <Comp.Access.AdminRoute exact path={match.path + "/settings"} render={(props) => <Settings abstract={a!} eventId={eventId} { ...props} />} />
                    </>
                    : null
                }
            </div>

        </Comp.Page.AdminPage>;
    }
}

export const Edit: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(EditComponent) as any);



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/edit/Edit.tsx